<!--
* 组件名 : 图片墙
* 开发者 : JY
*
* 参数:
*  data     { Array }   required - 图片墙卡片信息
*
* 事件:     
* itemClick  []  -  点击图片打开图片管理器
* 
*
-->

<template>
  <div class="v-picture-wall">
    <div class="track swiper-container picture-wall-swiper" ref="track">
      <div class="swiper-wrapper">
        <picture-wall-card
          class="swiper-slide"
          v-for="(item, i) in data"
          :index="i"
          :key="i"
          :image="item.min"
          :title="item.description"
          :paint="item.max"
          :slug="item.slug"
          @itemClick="on_item_click(i)"
          @update="update_swiper_fn(true)"
        />
      </div>
      <div class="truck-operate">
        <div class="process-bar" />
        <div class="control-box" ref="controlBox">
          <v-btn class-name="prev" :linear="true">
            <v-icon>west</v-icon>
          </v-btn>
          <v-btn class-name="next" :linear="true">
            <v-icon>east</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPaintImagePath, timeout } from "@/utils/util";
import pictureWallCard from "./components/picture-wall-card/index.vue";
export default {
  name: "v-picture-wall",
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  components: {
    pictureWallCard,
  },
  data() {
    this.pictureWallSwiper = null;
    return {
      processWidth: "1%",
    };
  },
  created() {
    //  通过 slug来匹配图片
    this.data.map((item, index) => {
      let imgLink = getPaintImagePath(item.slug);
      this.data[index].min = imgLink.min;
      this.data[index].max = imgLink.max;
    });
  },

  mounted() {
    this.swiper_track();
  },
  methods: {
    //  点击打开图片查看器调用数据
    on_item_click(index) {
      this.$paintViewer({
        carousel: this.data,
        current: index,
        swiper: this.pictureWallSwiper,
      });
    },

    /**
     * swiper 插件配置
     */
    async swiper_track() {
      let swiperOptions = {
        freeMode: true,
        speed: 1000,
        slidesPerView: "auto",
        grabCursor: true,
        spaceBetween: 0,
        centeredSlides: false,
        freeModeMinimumVelocity: 1,
        freeModeMomentumRatio: 0.6,
        freeModeMomentumVelocityRatio: 0.8,
        init: true,
        pagination: {
          el: ".process-bar",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".control-box .next",
          prevEl: ".control-box .prev",
        },
      };

      // await timeout(1000);
      this.pictureWallSwiper = new Swiper(
        ".picture-wall-swiper",
        swiperOptions
      );
    },

    /**
     * 更新 swiper 内置方法
     */
    update_swiper_fn(status) {
      if (this.pictureWallSwiper.length) {
        this.pictureWallSwiper.map((item, i) => {
          status ? item.update() : item.destroy(true, true);
        });
      } else {
        status
          ? this.pictureWallSwiper.update()
          : this.pictureWallSwiper.destroy(true, true);
      }
    },
  },
  beforeDestroy() {
    //  swiper 销毁不干净
    this.update_swiper_fn(false);
    this.pictureWallSwiper = null;
  },
};
</script>

<style lang="scss">
.v-picture-wall {
  padding-top: 40px;

  .track {
    width: 100%;
    height: 820px;
    position: relative;
    overflow: hidden;
    user-select: none;
    outline: none;
    // margin-bottom: -4%;
    z-index: 4;
  }

  .picture-wall-card {
    box-sizing: content-box;
    position: relative;

    &:nth-of-type(1) {
      padding-left: 6vw;
    }

    // &:nth-last-of-type(1) {
    //   margin-right: 0;
    // }
  }

  .control-box {
    display: flex;
  }

  .truck-operate {
    position: relative;
    height: 56px;
    overflow: hidden;
    margin-top: -56px;
    z-index: 2;

    .process-bar {
      margin-top: 24px;
    }

    .swiper-pagination-progressbar-fill {
      background-color: #3a3a3a;
    }

    .control-box {
      position: absolute;
      top: 4px;
      right: 8px;

      button {
        margin-right: 32px;

        will-change: transform;

        i {
          color: #3a3a3a;
        }
      }
    }
  }

  @media (max-width: $lx-max) {
    .track {
      height: 746px;
    }
  }

  @media (max-width: $lx-min) {
    .track {
      height: 626px;
    }
  }
}
</style>
